"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _ethers = require("ethers"),
    _formatBN = require("./lib/formatBN"),
    _default = function _default() {
  return (
    /*#__PURE__*/

    /**
    * Format a percentage amount
    *
    * @param {*} value The number to be formatted as a percentage
    * @param {*} [base=10^18] The number that is considered to be 100% when calculating the percentage
    * @param {*} [precision=2] The number of decimal places to format to
    * @return {Promise<radspec/evaluator/TypedValue>}
    */
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(value) {
        var base,
            precision,
            valueBn,
            baseBn,
            oneHundred,
            formattedAmount,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                base = _args.length > 1 && _args[1] !== undefined ? _args[1] : (0, _formatBN.tenPow)(18);
                precision = _args.length > 2 && _args[2] !== undefined ? _args[2] : 2;
                valueBn = _ethers.BigNumber.from(value), baseBn = _ethers.BigNumber.from(base), oneHundred = (0, _formatBN.tenPow)(2), formattedAmount = (0, _formatBN.formatBN)(valueBn.mul(oneHundred), baseBn, +precision);
                return _context.abrupt("return", {
                  type: "string",
                  value: "".concat(formattedAmount)
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.default = _default;